function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoAppsAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M560.77,99.569h-185.761v260.762h185.761c9.191,0,16.649-7.458,16.649-16.649V116.2c0-9.19-7.458-16.649-16.649-16.649v.018Z",
    style: {
      fill: "#cbd0d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.23,99.569c-9.19,0-16.649,7.458-16.649,16.649v227.483c0,9.191,7.458,16.649,16.649,16.649h185.761V99.569h-185.761Z",
    style: {
      fill: "#a4b0c2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.364,
    y: 112.334,
    width: 379.29,
    height: 189.645,
    rx: 3.884,
    ry: 3.884,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.95,360.332h-29.176v27.353h-32.823v12.765h82.058v-20.059c-11.087,0-20.059-8.972-20.059-20.059Z",
    style: {
      fill: "#cbd0d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.244,387.684h-32.823v-27.353h-27.353c0,11.087-8.972,20.059-20.059,20.059v20.059h80.234v-12.765Z",
    style: {
      fill: "#a4b0c2"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "343.898 153.61 323.472 174.037 303.046 153.61 294.875 161.78 315.301 182.208 294.875 202.633 303.046 210.804 323.472 190.379 343.898 210.804 352.069 202.633 331.643 182.208 352.069 161.78 343.898 153.61",
    style: {
      fill: "#534b62"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.143 161.78 446.972 153.61 426.546 174.037 406.12 153.61 397.949 161.78 418.375 182.208 397.949 202.633 406.12 210.804 426.546 190.379 446.972 210.804 455.143 202.633 434.717 182.208 455.143 161.78",
    style: {
      fill: "#534b62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.766,260.704c-43.224-29.846-87.009-.302-87.449,0l-5.667-8.21c.492-.341,49.962-33.714,98.784,0l-5.667,8.21Z",
    style: {
      fill: "#534b62"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAppsAvailable);
export default __webpack_public_path__ + "static/media/NoAppsAvailable.e9e897cfe4d7cda2b597034557673caa.svg";
export { ForwardRef as ReactComponent };